// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//test
import Vue from 'vue';
import App from './App';
// import axios from 'axios';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies'
Vue.config.productionTip = false;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store'
Vue.use(ElementUI);
Vue.use(VueAxios, axios);  // 请求接口
Vue.use(VueCookies)

// 头像裁剪
import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

import './assets/index.css'; // 分页器的全局样式

//引入echarts图表
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

//引入复制链接功能
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


let baseUrl = 'https://www.lingxinyun.cn';
// let baseUrl = 'https://192.168.10.128';
//let baseUrl = 'http://192.168.10.188:80';
//let baseUrl = 'http://localhost';
 const http = axios.create()

// 添加token
axios.interceptors.request.use(
  config => {
    config.cancelToken = new axios.CancelToken((cancel) => {
            //使用vuex 定义pushCancel，请求进来存入
            store.dispatch('pushCancel', {cancelToken:cancel})
          });
  // 判断是否存在token，如果存在的话，则每个http header都加上token
    let token = VueCookies.get('token')
    if (!config.headers.hasOwnProperty('Authorization') && token) {
      config.headers["X-Psy-Token"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
});

/* 响应拦截器 */
axios.interceptors.response.use(function (response) { // ①10010 token过期（30 天） ②10011 token无效
  if (response.data.errno === 501) {
    store.dispatch('clearCancel');
      ElementUI.Message({
        message: '请先登录',
        type: 'error',
        duration:1000
      });
    VueCookies.remove('token');
    VueCookies.remove('identification');
    VueCookies.remove('avatar');
    VueCookies.remove('nickname');
    router.replace({path: '/login'});

  } else {
    // 刷新token
    const loginTime= VueCookies.get('loginTime');
    const token = VueCookies.get('token');
    if(token && loginTime){//有没有token
      const nowTime = new Date().getTime();
      const resetTime = 1 * 60 * 60 * 1000; //刷新最小间隔时间

      if (nowTime - loginTime > resetTime && nowTime - loginTime < 2 * 60 * 60 * 1000) {//当前时间超过token存储时间resetTime毫秒时刷新token
        axios.post(baseUrl+'/pc/auth/refresh/token',{}).then((res) => {
          VueCookies.set("token", res.data.data);  // 存储token
          VueCookies.set("loginTime", nowTime); //存储 token存储时的时间
        }).catch(err => {});
     } else if (nowTime - loginTime >= 2 * 60 * 60 * 1000) {
        ElementUI.Message({
          message: '登录已过期',
          type: 'error',
          duration:1000
        });
        VueCookies.remove('token');
        VueCookies.remove('identification');
        VueCookies.remove('avatar');
        VueCookies.remove('nickname');
        location.reload()
      }
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error)
})


// 导航守卫
router.beforeEach((to,form,next) =>{
    //如果进入到的路由是登录页或者注册页面，则正常展示
    if(to.path === '/HomePage'){
      // sessionStorage.clear(); // 清除缓存
        next();
    }else{
        next();
    }
})
//加入百度统计
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// 引入element组件
import 'element-ui/lib/theme-chalk/index.css'
import elementUI from 'element-ui'
// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
elementUI.Dialog.props.lockScroll.default = false;
Vue.use(elementUI)

import './images/icon/iconfont.css'



// WEBPACK FOOTER //
// ./src/main.js